module.exports = __webpack_public_path__ + "static/img/kaishu_benefit_btn1.17e33bf5.png";